const cartArr = {
    state: {
        Arr: []
    },
    mutations: {
        SET_CARTARR(state, data) {
            state.Arr = data;

        }
    },
    actions: {
        setCartArr(ctx, arr) {
            ctx.commit('SET_CARTARR', arr);
        }
    }
}

export default cartArr


// WEBPACK FOOTER //
// ./src/store/modules/cartArr.js